import sortButton from "../../assets/sortbutton.svg";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout, MdKeyboardArrowLeft } from "react-icons/md";
import Button from "react-bootstrap/Button";
import {
  VoucherExportApi,
  VoucherTransactionsApi,
} from "../../Utils/Api/VoucherTransactionsApi";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import { format } from "date-fns";
import { Image } from "react-bootstrap";
import view from "../../assets/view.svg";
import Pagination from "../../Components/Pagination/Pagination";
import Loader from "../../Components/Loader/Loader";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { saveAs } from "file-saver";
import Navigation from "../Navigation/Navigation";
import Balance from "../../assets/balance.svg";
import { BusinessTansactionListApi } from "../../Utils/Api/BusinessTansactionListApi";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { toast } from "react-toastify";
import getFormatedDate from "../../Utils/DateFormatter";
import SearchBarResults from "../../Components/Search/SearchBarResults";

const TransactionsInnerTransaction = () => {
  const [currentTab, setcurrentTab] = useState("");

  const [busnessListData, setBusnessListData] = useState([]);
  const [balanceAmount, setBalanceAmount] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [flag, setFlag] = useState({
    Date: 0,
    TransactionId: 0,
    TransactionType: 0,
    MarketplaceName: 0,
    TransactionName: 0,
    TransactionAmount: 0,
    TransactionFees: 0,
    NetAmount: 0,
    Balance: 0,
  });

  const path = window.location.href;
  const endPath = path.split("/");

  const navigate = useNavigate();

  const BuId = userId();

  const onSearch = (e) => {
    let searchVal = e.target.value;
    setSearch(searchVal);
    if (!searchVal) {
      setSearch("");
      BusinessTransactionListApi("", "", "");
    }
  };

  const SearchHandler = () => {
    BusinessTransactionListApi(search, "", "");
    // setResultsFor(true);
  };

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      BusinessTransactionListApi(search, "", "");
    }
  };

  /////////////////////////////////////////// Sort Functions /////////////////////////////////////////////

  const handleSortDate = () => {
    if (flag.Date === 0) {
      BusinessTransactionListApi(search, 1, "apb_date");
      setFlag((ps) => {
        return {
          ...ps,
          Date: 1,
          TransactionId: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.Date === 1) {
      BusinessTransactionListApi(search, 2, "apb_date");
      setFlag((ps) => {
        return {
          ...ps,
          Date: 2,
          TransactionId: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          Date: 0,
          TransactionId: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortTransactionId = () => {
    if (flag.TransactionId === 0) {
      BusinessTransactionListApi(search, 1, "apb_transaction_id");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionId: 1,
          Date: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.TransactionId === 1) {
      BusinessTransactionListApi(search, 2, "apb_transaction_id");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionId: 2,
          Date: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionId: 0,
          Date: 0,
          TransactionType: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortTransactionType = () => {
    if (flag.TransactionType === 0) {
      BusinessTransactionListApi(search, 1, "apb_payment_method");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionType: 1,
          TransactionId: 0,
          Date: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.TransactionType === 1) {
      BusinessTransactionListApi(search, 2, "apb_payment_method");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionType: 2,
          TransactionId: 0,
          Date: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          MarketplaceName: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortMarketplaceName = () => {
    if (flag.MarketplaceName === 0) {
      BusinessTransactionListApi(search, 1, "mms_city_name");
      setFlag((ps) => {
        return {
          ...ps,
          MarketplaceName: 1,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.MarketplaceName === 1) {
      BusinessTransactionListApi(search, 2, "mms_city_name");
      setFlag((ps) => {
        return {
          ...ps,
          MarketplaceName: 2,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionName: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortTransactionName = () => {
    if (flag.TransactionName === 0) {
      BusinessTransactionListApi(search, 1, "product_name");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionName: 1,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.TransactionName === 1) {
      BusinessTransactionListApi(search, 2, "product_name");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionName: 2,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionAmount: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortTransactionAmount = () => {
    if (flag.TransactionAmount === 0) {
      BusinessTransactionListApi(search, 1, "apb_amount");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionAmount: 1,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.TransactionAmount === 1) {
      BusinessTransactionListApi(search, 2, "apb_amount");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionAmount: 2,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          TransactionFees: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortTransactionFees = () => {
    if (flag.TransactionFees === 0) {
      BusinessTransactionListApi(search, 1, "apb_transaction_fee");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionFees: 1,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else if (flag.TransactionFees === 1) {
      BusinessTransactionListApi(search, 2, "apb_transaction_fee");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionFees: 2,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          NetAmount: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortNetAmount = () => {
    if (flag.NetAmount === 0) {
      BusinessTransactionListApi(search, 1, "apb_net_amount");
      setFlag((ps) => {
        return {
          ...ps,
          NetAmount: 1,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          Balance: 0,
        };
      });
    } else if (flag.NetAmount === 1) {
      BusinessTransactionListApi(search, 2, "apb_net_amount");
      setFlag((ps) => {
        return {
          ...ps,
          NetAmount: 2,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          Balance: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          NetAmount: 0,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
          Balance: 0,
        };
      });
    }
  };

  const handleSortBalance = () => {
    if (flag.Balance === 0) {
      BusinessTransactionListApi(search, 1, "apb_balance_amount");
      setFlag((ps) => {
        return {
          ...ps,
          Balance: 1,
          NetAmount: 0,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
        };
      });
    } else if (flag.Balance === 1) {
      BusinessTransactionListApi(search, 2, "apb_balance_amount");
      setFlag((ps) => {
        return {
          ...ps,
          Balance: 2,
          NetAmount: 0,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
        };
      });
    } else {
      BusinessTransactionListApi(search, 0, "");
      setFlag((ps) => {
        return {
          ...ps,
          Balance: 0,
          NetAmount: 0,
          TransactionFees: 0,
          TransactionAmount: 0,
          TransactionName: 0,
          MarketplaceName: 0,
          TransactionType: 0,
          TransactionId: 0,
          Date: 0,
        };
      });
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  // API call
  const BusinessTransactionListApi = async (searchval, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }

    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));

    if (colName === "") {
      const data = {
        business_id: BuId,
        search_value: searchval,
        limit: 10,
        offset: searchval ? 0 : pageNumber,
      };
      if (colName !== "" && !data.sort_type && !data.column_name) {
        setLoading(true);
      }
      if (colName !== "" && !data.sort_type && !data.column_name) {
        setLoading(true);
        window.scrollTo(0, 100);
      }
      const BusinessTransactionListRes = await BusinessTansactionListApi(
        data,
        () => {
          navigate("/");
        }
      );
      if (BusinessTransactionListRes === false) {
        toast.error(ServerError, {
          position: "top-center",
          width: "auto",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (BusinessTransactionListRes.success === true) {
          setTotalPageCount(BusinessTransactionListRes.total_rows);
          setBusnessListData(BusinessTransactionListRes.data);
          setLimit(BusinessTransactionListRes.limit);
          setBalanceAmount(BusinessTransactionListRes.balance_amount);
          setBusinessName(BusinessTransactionListRes.business_name);
          setLoading(false);
        }else if (BusinessTransactionListRes.status === 429) {
          setLoading(true);
          toast.error(BusinessTransactionListRes.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          setBusnessListData([]);
          setBalanceAmount(BusinessTransactionListRes.balance_amount);
          setBusinessName(BusinessTransactionListRes.business_name);
          setTotalPageCount(0);
          setLimit(10);
          setLoading(false);
        }
      }
    } else {
      const data = {
        business_id: BuId,
        search_value: searchval,
        limit: 10,
        offset: searchval ? 0 : pageNumber,
        column_name: ColName ? ColName : colName,
        sort_type: SortVal ? SortVal : sortval,
      };
      if (!data.sort_type && !data.column_name) {
        setLoading(true);
      }
      if (colName !== "" && !data.sort_type && !data.column_name) {
        setLoading(true);
        window.scrollTo(0, 100);
      }
      const BusinessTransactionListRes = await BusinessTansactionListApi(
        data,
        () => {
          navigate("/");
        }
      );
      if (BusinessTransactionListRes === false) {
        toast.error(ServerError, {
          position: "top-center",
          width: "auto",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        if (!data.sort_type && !data.column_name) {
          setLoading(false);
        }
      } else {
        if (BusinessTransactionListRes.success === true) {
          setBusnessListData(BusinessTransactionListRes.data);
          setTotalPageCount(BusinessTransactionListRes.total_rows);
          setLimit(BusinessTransactionListRes.limit);
          setBalanceAmount(BusinessTransactionListRes.balance_amount);
          setBusinessName(BusinessTransactionListRes.business_name);
          setLoading(false);
        }else if (BusinessTransactionListRes.status === 429) {
          setLoading(true);
          toast.error(BusinessTransactionListRes.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          setBusnessListData([]);
          setBalanceAmount(BusinessTransactionListRes.balance_amount);
          setBusinessName(BusinessTransactionListRes.business_name);
          setTotalPageCount(0);
          setLimit(10);
          setLoading(false);
        }
      }
    }
  };

  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    BusinessTransactionListApi();
  }, [pageNumber]);

  useEffect(() => {
    if (endPath[4] === "inner-transactions") {
      setcurrentTab("inner-transactions");
    }
  }, []);

  return (
    <>
      {loading === true ? <Loader /> : <></>}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/dashboard">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Transactions</p>
          <div className="acc-dashboard mt-4">
            <div className="tabs_ul mb-2">
              <NavLink
                to={"/transactions/vouchers"}
                className={currentTab === "vouchers" ? "activeTab" : "tabs_li"}
              >
                Vouchers
              </NavLink>
              <NavLink
                to={"/transactions/coupons"}
                // onClick={(e) => handleToggleTab(0)}
                className={currentTab === "coupons" ? "activeTab" : "tabs_li"}
              >
                Coupons
              </NavLink>
              <NavLink
                to={"/transactions/inner-transactions"}
                // onClick={(e) => handleToggleTab(0)}
                className={
                  currentTab === "inner-transactions" ? "activeTab" : "tabs_li"
                }
              >
                Transactions
              </NavLink>
            </div>
            <div className="manage-vou-main pt-3 pb-3 Tran-sub-titles">
              <p className="page-maintitle pt-2">Transactions</p>
              <div className="manage-vou">
                <InputGroup className="search-bar">
                  <InputGroup.Text>
                    <MdSearch />
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      maxLength={20}
                      onChange={onSearch}
                      value={search}
                      onKeyPress={handleKeypress}
                    />
                  </InputGroup.Text>
                  <Form.Control />
                  <Button variant="outline-secondary" onClick={SearchHandler}>
                    Search
                  </Button>
                </InputGroup>
                {/* <Button
                  variant="primary"
                  className="create-btn export-btn-main"
                >
                  Export <MdOutlineLogout className="export-btn" />
                </Button> */}
                <p className="tran-balance">
                  <img loading="lazy" src={Balance} />
                  Balance : ${balanceAmount ? balanceAmount : 0.0}
                </p>
              </div>
            </div>
            <SearchBarResults SearchValue={search} />
            <div className="table-responsive-xl black-header innerTran">
              <table className="recentact-table mt-3 table ver-middle manage-vou-table innerTransactionTable">
                <thead>
                  <tr className="innerTran-tr-head">
                    <th>
                      <div
                        className="tableheaders"
                        style={{ justifyContent: "initial" }}
                      >
                        Date
                        <div className="SortButton">
                          <Button onClick={handleSortDate}>
                            {flag.Date === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.Date === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div
                        className="tableheaders"
                        style={{ justifyContent: "center" }}
                      >
                        Transaction ID
                        <div className="SortButton">
                          <Button onClick={handleSortTransactionId}>
                            {flag.TransactionId === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.TransactionId === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="tableheaders">
                        Transaction Type
                        <div className="SortButton">
                          <Button onClick={handleSortTransactionType}>
                            {flag.TransactionType === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.TransactionType === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="tableheaders">
                        Marketplace
                        <div className="SortButton">
                          <Button onClick={handleSortMarketplaceName}>
                            {flag.MarketplaceName === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.MarketplaceName === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div
                        className="tableheaders"
                        style={{ justifyContent: "initial" }}
                      >
                        Transaction Name
                        <div className="SortButton">
                          <Button onClick={handleSortTransactionName}>
                            {flag.TransactionName === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.TransactionName === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    {/* <th>
                      <div className="tableheaders">
                        Customer Name
                        <div className="SortButton">
                          <Button onClick={h}>
                            {flag.Date === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.Date === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th> */}
                    {/* <th>
                      <div className="tableheaders">
                        Transaction ID
                        <div className="SortButton">
                          <Button onClick={}>
                            {flag.Date === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.Date === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>*/}
                    <th>
                      <div className="tableheaders">
                        Transaction Amount
                        <div className="SortButton">
                          <Button onClick={handleSortTransactionAmount}>
                            {flag.TransactionAmount === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.TransactionAmount === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="tableheaders">
                        Transaction Fees
                        <div className="SortButton">
                          <Button onClick={handleSortTransactionFees}>
                            {flag.TransactionFees === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.TransactionFees === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="tableheaders">
                        Net Amount
                        <div className="SortButton">
                          <Button onClick={handleSortNetAmount}>
                            {flag.NetAmount === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.NetAmount === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="tableheaders">
                        Balance
                        <div className="SortButton">
                          <Button onClick={handleSortBalance}>
                            {flag.Balance === 0 ? (
                              <>
                                <FaSort />
                              </>
                            ) : flag.Balance === 1 ? (
                              <FaSortUp />
                            ) : (
                              <FaSortDown />
                            )}
                          </Button>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {busnessListData?.length > 0 ? (
                    busnessListData.map((data, i) => {
                      return (
                        <tr className="innerTran-tr-body" key={i}>
                          <td>
                            {data.apb_date
                              ? getFormatedDate(data.apb_date)
                              : "-"}
                          </td>
                          <td>
                            {data.apb_transaction_id
                              ? data.apb_transaction_id
                              : "-"}
                          </td>
                          <td>
                            {data.apb_payment_method
                              ? data.apb_payment_method
                              : "-"}
                          </td>
                          <td>
                            {data.mms_city_name ? data.mms_city_name : "-"}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {data.apb_payment_method === "debit"
                              ? ""
                              : "Payments sent via"}{" "}
                            {data.product_name ? data.product_name : "-"}
                          </td>
                          <td>${data.apb_amount ? data.apb_amount : 0}</td>
                          <td>
                            $
                            {data.apb_transaction_fee
                              ? data.apb_transaction_fee
                              : 0}
                          </td>
                          <td>
                            ${data.apb_net_amount ? data.apb_net_amount : 0}
                          </td>
                          <td>
                            $
                            {data.apb_balance_amount
                              ? data.apb_balance_amount
                              : 0}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <td colSpan={9}>
                      <p className="NoDataAvailable">No data available!</p>
                    </td>
                  )}
                  {/* <tr className="innerTran-tr-body">
                    <td>Nov-11-2023</td>
                    <td>#2110</td>
                    <td>Olympia</td>
                    <td>Debit</td>
                    <td>$20 Sam's Club Membership</td>
                    <td>Smith</td>
                    <td>1234-1234-1234</td>
                    <td>$25.00</td>
                    <td>$03.75</td>
                    <td>$21.25</td>
                    <td>$123.25</td>
                  </tr> */}
                </tbody>
              </table>
            </div>
            <div>
              {totalPageCount > 10 ? (
                <Pagination
                  Limit={limit}
                  SetPageNumber={setPageNumber}
                  TotalPageCount={totalPageCount}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionsInnerTransaction;
